import * as React from 'react';
import { toLongDateTime } from '../../../../utils/date-utils';
import { SearchEventSummary } from '../../../../support/models/activity/search-event-summary';
import { EventStatusMetadata } from '../../../../support/models/enums/event-status';
import { EventTypeMetadata } from '../../../../support/models/enums/event-type';

interface IProps {
    event : SearchEventSummary;
}

export const SupportActivityRow = (props: IProps) => (

    <tr>
        <td className={ `activity-event-status ${EventStatusMetadata[props.event.status].class}` }>{ props.event.id }</td>
        <td>{ props.event.eventId }</td>
        {/* <td>{ EventTypeMetadata[props.event.type].display }</td> */}
        <td>{ props.event.typeName }</td>
        <td>{ props.event.correlationId }</td>
        <td>{ props.event.causationId }</td>
        <td>{ props.event.userId }</td>
        <td>{ props.event.entity }</td>
        <td>{ toLongDateTime(props.event.createdOn)  }</td>
    </tr>

);
